"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconSVGInline = void 0;
var honeycomb_1 = require("@honeycomb-npm/honeycomb");
var PropTypes = require("prop-types");
var React = require("react");
var sanitize_1 = require("../../utils/sanitize");
var IconSVGInline = function (props) {
    var isBankwest = props.theme && props.theme.toLowerCase() === 'bankwest';
    var iconlist = isBankwest ? honeycomb_1.BWIcons.IconList : honeycomb_1.Icons.IconList;
    if (typeof iconlist[props.symbol] === 'undefined') {
        // Icon does not exist
        return null;
    }
    var icon = iconlist[props.symbol];
    if (typeof icon.svginline === 'undefined') {
        // Icon is not available as an inline SVG
        return null;
    }
    var html = icon.svginline(props.args);
    return (React.createElement("span", { dangerouslySetInnerHTML: (0, sanitize_1.sanitize)(html), "aria-hidden": true, className: props.className }));
};
exports.IconSVGInline = IconSVGInline;
var concatedList = __assign(__assign({}, honeycomb_1.Icons.IconList), honeycomb_1.BWIcons.IconList);
exports.IconSVGInline.propTypes = {
    args: PropTypes.object,
    className: PropTypes.string,
    symbol: PropTypes.oneOf(Object.keys(concatedList).filter(function (iconname) {
        if (typeof concatedList[iconname].svginline === 'undefined') {
            return false;
        }
        return true;
    })).isRequired,
    theme: PropTypes.string,
};
